import React from "react";

const GymIcon = (props) => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M22.2316 10.6594C23.0593 10.6594 23.4048 9.59598 22.7325 9.1058L12.503 1.66473C12.357 1.5577 12.1806 1.5 11.9995 1.5C11.8184 1.5 11.642 1.5577 11.4959 1.66473L1.26643 9.1058C0.594111 9.5933 0.939647 10.6594 1.77 10.6594H3.42804V20.6772H1.49947C1.38161 20.6772 1.28518 20.7737 1.28518 20.8915V22.2844C1.28518 22.4022 1.38161 22.4987 1.49947 22.4987H22.4995C22.6173 22.4987 22.7138 22.4022 22.7138 22.2844V20.8915C22.7138 20.7737 22.6173 20.6772 22.4995 20.6772H20.5709V10.6594H22.2316ZM11.9995 3.55312L19.2611 8.83527H4.73786L11.9995 3.55312ZM5.35661 10.6594H8.49054V20.6772H5.35661V10.6594ZM10.4191 10.6594H13.553V20.6772H10.4191V10.6594ZM18.6423 20.6772H15.4816V10.6594H18.6423V20.6772Z"
				fill={"currentColor"}
				fill-opacity="0.85"
			/>
		</svg>
	);
};

export default GymIcon;

